import React, { useMemo } from "react";
import { useForm } from "react-hook-form";

import useTranslations from "../../../hooks/useTranslations";

import { FormStepProps } from "../../../screens/MadFormScreen";

import {
  Button,
  ScreenHeader,
} from "../../wombat-ui";
import { MadIcon } from "../../icons";

import MadConfigurationForm from './MadConfigurationForm';

type NextStepButtonControlProps = {
  formState: ReturnType<typeof useForm>["formState"];
  disabled?: boolean;
};

const NextStepButtonControl: React.FC<NextStepButtonControlProps> = React.memo(
  ({ formState, disabled = false }) => {
    const t = useTranslations();
    const _disabled = useMemo(() => {
      return formState.errors.startDate !== undefined;
    }, [formState]);

    return (
      <Button disabled={_disabled || disabled} type="submit">
        {t("mads.launch")}
      </Button>
    );
  }
);

const ThirdStep: React.FC<Omit<FormStepProps, "onNext">> = (props) => {
  const t = useTranslations();

  return (
    <>
      <ScreenHeader
        icon={MadIcon}
        title={t("mads.new")}
        description={t("mads.launch")}
        actions={[
          <NextStepButtonControl
            formState={props.formState}
            key="next"
          />,
        ]}
      />
      <MadConfigurationForm {...props} />
    </>
  );
};

export default React.memo(ThirdStep);
